import { hillo } from 'hillo'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import GlobalConfig from '@/model/global/GlobalSettings'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { ageDisplay } from '@/model/dataLayer/api/Vip/UserDetail'

const BLSubscription = 'membership/subscription/'

const entity = {
  username: {},
  email: {},
  ageDisplay: {
    form: false
  },
  gender: {
    form: false
  },
  lastLoginAt: {
    header: false
  },
  lastLoginDisplay: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  createTimestamp: {
    header: false
  },
  // createTimestampDisplay: {
  //   type: IKDataEntity.Types.Integer,
  //   form: false,
  //   tableConfig: {
  //     overwrite: true
  //   }
  // },
  distributedVoucher: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}

const config = {
  load: async function () {
    return (await hillo.get(cloudV2Url + BLSubscription + 'subscribedUsers/' + GlobalConfig.blId)).map(it => {
      it.password = it.cloudUserInfo.password
      it.username = it.cloudUserInfo.username
      it.email = it.cloudUserInfo.email
      it.refUserId = it.cloudUserInfo.refUserId
      it.phoneNumber = it.cloudUserInfo.phoneNumber
      it.otp = it.cloudUserInfo.otp
      it.otpGeneratedAt = it.cloudUserInfo.otpGeneratedAt
      it.enabled = it.cloudUserInfo.enabled
      it.accountNonLocked = it.cloudUserInfo.accountNonLocked
      it.accountLockedAt = it.cloudUserInfo.accountLockedAt
      it.createTimestamp = it.cloudUserInfo.createTimestamp
      it.lastLoginAt = it.cloudUserInfo.lastLoginAt
      it.ageDisplay = ageDisplay(it.cloudUserInfo.birthDay)
      it.gender = it.cloudUserInfo.gender
      return it
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
const commonPath = 'common/businessLayer/'

export async function updateBusinessLayerDisplayInfo (item) {
  return (await hillo.jsonPost(cloudV2Url + commonPath + 'updateDisplayInfo', {
    ...item
  }))
}
